import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons'
import { Button, Form, Space, Switch, Tooltip } from 'antd'
import get from 'lodash.get'
import React, { useEffect, useState } from 'react'
import {
  convertPriceToNumber,
  formatCurrencyLabel,
  formatCurrencyUnit,
  hasPermission,
  removeNullUndefined
} from '../../config-func'
import { ACTION_MODE, PAGE_SIZE_OPTIONS } from '../../configData'
import {
  deleteItemPakge,
  getPakageCommunity,
  pakageCommunityAdd,
  pakageCommunityDetail,
  pakageCommunityUpdate
} from '../../services/pakage-community-service'
import Card from '../Card'
import ModalCustom from '../common/Modal/ModalCustom'
import ModalConfirm, { showConfirm } from '../common/ModalConfirm/ModalConfirm'
import openNotification from '../common/Notification/openNotification '
import TableField from '../common/Table/TableField'
import FilterForm from './FilterForm'
import FormPost from './FormPost'
import Loading from '../Loading';
const PakageCommunity = () => {
  const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [mode, setMode] = useState(ACTION_MODE.VIEW)
  const [form] = Form.useForm()
  const [dataSource, setDataSource] = useState([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(false)

  const [filters, setFilters] = useState({
    currentPage: 1,
    pageSize: 10
  })

  const handleSearch = () => {
    if (filters.currentPage === 1) {
      fetchData()
    } else {
      setFilters((prev) => ({ ...prev, currentPage: 1 }))
    }
  }

  async function fetchData() {
    setLoading(true)

    let _dataSource = []
    let _total = 0

    const params = {
      page: filters.currentPage,
      pageSize: filters.pageSize,
      title: filters.title || '',
      // status: filters.status || ''
    }

    const cleanedData = Object.fromEntries(
      Object.entries(params).filter(
        ([_, value]) => value !== '' && value !== null && value !== undefined
      )
    )

    try {
      const response = await getPakageCommunity(cleanedData)
      _total = response?.data?.total
      _dataSource = response?.data?.list
      // }
    } catch (error) {
      openNotification(
        'error',
        error?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    } finally {
      setLoading(false)
      setTotal(_total)
      setDataSource(_dataSource)
    }
  }

  useEffect(() => {
    fetchData()
  }, [filters.currentPage, filters.pageSize, filters.reset])
  // -=0-=0-====================================================================================================
  // Columns for Table
  const initialColumns = [
    {
      title: 'STT',
      dataIndex: 'stt',
      key: 'stt',
      fixed: 'left',
      width: 60,
      align: 'center',
      render: (_, __, index) =>
        (filters.currentPage - 1) * filters.pageSize + index + 1
    },
    {
      title: 'Tên gói',
      dataIndex: 'name',
      key: 'name',
      width: 150
    },
    {
      title: 'Loại gói',
      dataIndex: 'type',
      key: 'type',
      width: 150,
      render: (_, record) => <span>{record.type} tháng</span>
    },
    {
      title: 'Giá',
      dataIndex: 'original_price',
      key: 'original_price',
      width: 150,
      render: (_, record) => (
        <span>{formatCurrencyLabel(record.original_price)}</span>
      )
    },
    // {
    //   title: 'Giá khuyến mãi',
    //   dataIndex: 'promotion_price',
    //   key: 'promotion_price',
    //   width: 150,
    //   render: (_, record) => <span>{formatCurrencyLabel(record.promotion_price)}</span>
    // },
    {
      title: 'Số ngày khuyến mãi',
      dataIndex: 'promotion_date',
      key: 'promotion_date',
      width: 150
      // render: (_, record) => <span>{formatCurrencyLabel(record.promotion_price)}</span>
    },
    { title: 'Mô tả', dataIndex: 'content', key: 'content', width: 150 },
    // {
    //   title: 'Trạng thái',
    //   dataIndex: 'status',
    //   key: 'status',
    //   width: 150,
    //   render: (_, record) => <Switch checked={record.status === 1} />
    // },

    {
      title: 'Hành động',
      key: 'status',
      fixed: 'right',
      width: 150,
      render: (_, record) => {
        return (
          <Space size="small">
            <>
              {hasPermission('P53.2', permissions) && (
                <Tooltip title="Chỉnh sửa">
                  <Button
                    style={{ width: 32 }}
                    icon={<EditOutlined />}
                    onClick={() => {
                      setMode(ACTION_MODE.UPDATE)
                      getDetailPakageCommunity(record.id)
                    }}
                  />
                </Tooltip>
              )}
              {hasPermission('P53.3', permissions) && (
                <Tooltip title="Xóa">
                  <Button
                    style={{ width: 32 }}
                    icon={<DeleteOutlined style={{ color: 'red' }} />}
                    onClick={() =>
                      showConfirm({
                        title: 'Xác nhận xóa',
                        content: (
                          <div>
                            Bạn có chắc chắn muốn xóa <b>{record.name}</b>
                          </div>
                        ),
                        onOk: () => handleDelete(record.id)
                      })
                    }
                  />
                </Tooltip>
              )}
            </>
          </Space>
        )
      }
    }
  ]

  // Thêm sửa project
  const handleSave = async () => {
    setLoading(true)
    try {
      // Validate các trường trong form
      const values = await form.validateFields()
      // Kiểm tra nếu cả hai giá trị đều tồn tại
      const { id, ...data } = values
      let body = {}
      body = {
        ...data,
        original_price: values.original_price
          ? convertPriceToNumber(values.original_price?.toString())
          : 0,
        content: values.content || ''
        // promotion_price: values.promotion_price ? convertPriceToNumber(values.promotion_price?.toString()) : 0,
      }

      const dataParse = removeNullUndefined(body)
      const res =
        mode == ACTION_MODE.ADD
          ? await pakageCommunityAdd(dataParse)
          : await pakageCommunityUpdate(dataParse, id)

      form.resetFields()
      setIsModalOpen(false)
      fetchData()
      openNotification(
        'success',
        mode == ACTION_MODE.ADD
          ? 'Tạo mới cấu hình gói gia hạn Cộng đồng [App] thành công !'
          : 'Cập nhật cấu hình gói gia hạn Cộng đồng [App] thành công !'
      )
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message?.[0]?.message || 'Đã có lỗi xảy ra'
      )
    } finally {
      setLoading(false)
    }
  }

  // Chi tiết dự án
  const getDetailPakageCommunity = async (id) => {
    setLoading(true)
    try {
      const res = await pakageCommunityDetail(id) // Assuming roleSearch is an API function

      if (res && res.data) {
        setIsModalOpen(true)
        const values = res.data
        form.setFieldsValue({
          ...values
        })
      } else {
        openNotification('error', 'Có lỗi xảy ra, Vui lòng thử lại')
      }
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    } finally {
      setLoading(false)
    }
  }

  // Xóa project
  const handleDelete = async (ids) => {
    const body = {
      ids: [ids]
    }
    setLoading(true)
    try {
      const res = await deleteItemPakge(body || [])
      fetchData()
      openNotification('success', res.message)
    } catch (err) {
      const errors = get(err, 'response.data.data', [])
      const errorMessages =
        errors?.map((error) => error.message).join('\n') ||
        get(err, 'response.data.message', [])
      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
    }
  }

  //
  return (
    <div>
      <Loading loading={loading} />
      <Card className="mb-2">
        <FilterForm
          handleSearch={handleSearch}
          setFilters={setFilters}
          fetchData={fetchData}
        />
      </Card>

      <Card>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            margin: '0px 50px 10px 0px',
            width: '100%'
          }}
        >
          {/* <h2 className="text-2xl font-semibold my-2">Quản lý dự án</h2> */}
          <div style={{ marginLeft: 'auto', display: 'flex', gap: '8px' }}>
            {/* <Button
              type="primary"
              key="primary"
              onClick={() => {
                setIsModalImportOpen(true)
              }}
            >
              <PlusOutlined /> Import Excel
            </Button> */}
            {hasPermission('P53.1', permissions) && (
              <Button
                type="primary"
                // htmlType="submit"
                onClick={() => {
                  setIsModalOpen(true)
                  setMode(ACTION_MODE.ADD)
                }}
              >
                <PlusOutlined />
                Thêm mới
              </Button>
            )}
          </div>
        </div>
        <TableField
          loading={loading}
          columns={initialColumns}
          dataSource={dataSource}
          scroll={{ x: 'max-content', y: 'calc(100vh - 400px)' }}
          className={`custom-table`}
          // locale={{
          //   emptyText: <Empty description="Không có dữ liệu" />, // Hiển thị "Không có dữ liệu" khi bảng không có dữ liệu
          //   triggerDesc: 'Sắp xếp giảm dần', // Khi click vào cột để sort giảm dần
          //   triggerAsc: 'Sắp xếp tăng dần', // Khi click vào cột để sort tăng dần
          //   cancelSort: 'Hủy sắp xếp' // Khi bỏ sắp xếp
          // }}

          // columns={
          //   filters.isDefault === 'fixed'
          //     ? columns.filter(
          //         (item) => !['calculationMethod'].includes(item.dataIndex)
          //       )
          //     : columns.filter(
          //         (item) => !['isDefault'].includes(item.dataIndex)
          //       )
          // }

          pagination={{
            current: filters.currentPage,
            pageSize: filters.pageSize,
            total: total,
            pageSizeOptions: PAGE_SIZE_OPTIONS,
            showSizeChanger: true,
            onShowSizeChange: (current, size) => {
              setFilters((prev) => ({
                ...prev,
                pageSize: size,
                currentPage: 1
              }))
            },
            onChange: (page) => {
              setFilters((prev) => ({ ...prev, currentPage: page }))
            },
            showTotal: (total, range) =>
              `Hiển thị ${range[0]}-${range[1]} của ${total} bản ghi`,
            locale: { items_per_page: 'bản ghi / trang' }
          }}
          rowKey={(record, index) => index}
          locale={{ emptyText: 'Không có dữ liệu' }}
        />
      </Card>
      {/* Modal Thêm mới sản phẩm */}
      <ModalCustom
        title={
          mode == ACTION_MODE.UPDATE
            ? 'Chỉnh sửa cấu hình gói gia hạn cộng đồng App'
            : mode == 'ADD'
            ? 'Thêm mới cấu hình gói gia hạn cộng đồng App'
            : 'Xem chi tiết'
        }
        visible={isModalOpen}
        centered
        onCancel={() => {
          setIsModalOpen(false)
          form.resetFields()
        }}
        onConfirm={async () => {
          try {
            await form.validateFields() // Kiểm tra validation trước khi tiếp tục
            handleSave() // Nếu hợp lệ thì tiếp tục xử lý
          } catch (error) {
            console.log('Validation failed:', error)
          }
        }}
        confirmText={'Lưu'}
        cancelText="Đóng"
        footer={mode == 'VIEW' ? [''] : ''}
      >
        <FormPost form={form} handleSearch={handleSearch} mode={mode} />
      </ModalCustom>
      <ModalConfirm />
    </div>
  )
}

export default PakageCommunity
